<template>
  <div class="courses">
    <coach-header />
    <weui-group :notitle="true">
      <weui-button-cell :to="{ name: 'course.create' }">申请新课程</weui-button-cell>
    </weui-group>
    <weui-group v-show="later_has_more">
      <weui-button-cell @click="eventLoadFuture">展示更多未来课程</weui-button-cell>
    </weui-group>

    <weui-group v-for="week in later_courses" class="weekly-course" :title="`${week.end}之前的的课程`" :key="week.end">
      <course-link v-for="course in week.courses" :course="course" :key="course.id"/>
    </weui-group>

    <weui-group v-if="next" title="下一节课">
      <course-link :course="next"/>
    </weui-group>

    <weui-group v-for="week in earlier_courses" class="weekly-course" :title="`${week.end}之前的的课程`" :key="week.end">
      <course-link v-for="course in week.courses" :course="course" :key="course.id"/>
    </weui-group>

    <weui-group v-show="earlier_has_more">
      <weui-button-cell @click="eventLoadPast">展示更早之前已上课程</weui-button-cell>
    </weui-group>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import CoachHeader from '@/components/CoachHeader';
import { WeuiGroup, WeuiCell, WeuiButtonCell } from '@/components/weui';
import CourseLink from '@/components/course/Link';
import { FETCH_NEXT, FETCH_EARLIER_COURSES, FETCH_LATER_COURSES } from '@/store/course/types';

const { mapState, mapActions } = createNamespacedHelpers('course');

export default {
    computed: {
        ...mapState([
            'next',
            'later_courses',
            'later_has_more',
            'earlier_courses',
            'earlier_has_more',
        ]),
    },
    mounted() {
        this.fetchNext()
            .then(() => this.fetchEarlierCourses());
    },
    methods: {
        ...mapActions({
            fetchNext: FETCH_NEXT,
            fetchEarlierCourses: FETCH_EARLIER_COURSES,
            fetchLaterCourses: FETCH_LATER_COURSES,
        }),
        eventLoadPast() {
            this.fetchEarlierCourses();
        },
        eventLoadFuture() {
            this.fetchLaterCourses();
        },
    },
    components: {
        CoachHeader,
        WeuiGroup,
        WeuiCell,
        WeuiButtonCell,
        CourseLink,
    },
};
</script>



// WEBPACK FOOTER //
// src/containers/course/Home.vue